import {Dropdown} from '@/components-v2/molecules'
import {useRewardGiftItem} from '@/containers/Promotions/components/PromotionsConditions/Rewards/useRewardGiftItem'

/** v2 "<quantity> <gift item>" picker for gift item rewards. */
export const RewardGiftItem = ({promotionCondition, rewardIndex = 0}) => {
  const {
    quantityOptions,
    giftItemOptions,
    quantityValue,
    giftItemValue,
    isError,
    handleQuantityChange,
    handleGiftItemChange,
  } = useRewardGiftItem({promotionCondition, rewardIndex})

  return (
    <>
      <Dropdown
        width="120px"
        childList={quantityOptions}
        placeholder="Any"
        selectedValue={quantityValue}
        setSelectedValue={handleQuantityChange}
        isClearable={false}
        selection="single"
        error={isError}
        helperText={isError ? 'Value Invalid' : undefined}
        autoComplete="off"
      />
      <Dropdown
        childList={giftItemOptions}
        placeholder="Any"
        selectedValue={giftItemValue}
        setSelectedValue={handleGiftItemChange}
        isClearable={false}
        selection="single"
        autoComplete="off"
      />
    </>
  )
}
